import { TranslatableKey } from '@app/types/translatable.type';

const ChangeRequestStatuses: { [key: string]: TranslatableKey } = {
    pending: 'change-requests.changeRequestStatuses.pending',
    approved: 'change-requests.changeRequestStatuses.approved',
    denied: 'change-requests.changeRequestStatuses.denied',
    cancelled: 'change-requests.changeRequestStatuses.cancelled',
};

const ChangeRequestTemplateStatuses: { [key: string]: TranslatableKey } = {
    active: 'change-requests.changeRequestTemplateStatuses.active',
    inactive: 'change-requests.changeRequestTemplateStatuses.inactive',
};

export { ChangeRequestStatuses, ChangeRequestTemplateStatuses };
